import { useContext, useState } from 'react'
import { Alert, Button, Flex } from '@chakra-ui/react'

import { Cancellation, Check } from '../icons'
import { useCancelContract, useFreeCancelation } from '../hooks/useOrigApp'
import { insuranceParamsContext } from '../layouts/Wizard'

export const CancelContract = ({ isContracted, contractCanceled, insuranceId, callback, enableReactivation }:
  { isContracted: boolean, contractCanceled: boolean, insuranceId: number, callback: Function, enableReactivation: boolean }) => {

  const [error, setError] = useState<string | null>(null);
  const [confirmCancel, setConfirmCancel] = useState<boolean>(false)
  const [isCancelling, setIsCancelling] = useState<boolean>(false)
  const [isReactivating, setIsReactivating] = useState<boolean>(false)

  const { insuranceParamsId } = useContext(insuranceParamsContext)

  const [isCancelled, setCancelled] = useState<boolean>(contractCanceled)

  const { mutateAsync: cancelContract } = useCancelContract()
  const { mutateAsync: freeCancelation } = useFreeCancelation()

  const handleCancelConfirm = () => {
    setConfirmCancel(true)
  }

  const handleCancelContract = () => {
    setIsCancelling(true)

    cancelContract(insuranceId)
      .then((resp) => {
        if (resp.data.bStornovano) {
          callback()
          setCancelled(true)
          setError(null)
        }
        else {
          if (resp.data.stornoMsg11) {
            setError(resp.data.stornoMsg11)
          }
        }
      })
      .catch(() => setError('Při stornování došlo k chybě'))
      .finally(() => {
        setConfirmCancel(false)
        setIsCancelling(false)
      })
  }

  const handleReactivateContract = () => {
    setIsReactivating(true)

    freeCancelation(insuranceParamsId!)
      .then(() => {
        callback()
        setCancelled(false)
        setError(null)
      })
      .catch(() => {
        setError('Při reaktivaci došlo k chybě')
      })
      .finally(() => {
        setIsReactivating(false)
        setConfirmCancel(false)
      })
  }

  return (
    <>
      {!isCancelled && !confirmCancel && isContracted && (
        <Button variant="outline" colorScheme="red" onClick={handleCancelConfirm}>
          <Cancellation />
          Stornovat pro chybu ve smlouvě
        </Button>
      )}

      {!isCancelled && confirmCancel && (
        <Flex sx={{ gap: 2 }}>
          <Button
            variant="solid"
            colorScheme="red"
            onClick={handleCancelContract}
            disabled={isCancelling}
          >
            <Cancellation />
            {isCancelling ? 'Stornuji...' : 'Opravdu stornovat?'}
          </Button>

          {!isCancelling && (
            <Button variant="outline" onClick={() => setConfirmCancel(false)}>
              Nestornovat
            </Button>
          )}
        </Flex>
      )}

      {isCancelled && enableReactivation && (
        <Button
          variant="outline"
          colorScheme="green"
          onClick={handleReactivateContract}
          disabled={isReactivating}
        >
          <Check />
          {isReactivating ? 'Reaktivuji...' : 'Reaktivovat smlouvu'}
        </Button>
      )}

      {error && <Alert colorScheme="red">{error}</Alert>}
    </>
  )
}
